/** @jsxImportSource theme-ui */
import { Container, Box, Flex, Card, Heading, Text } from 'theme-ui';
import { useNavigate } from 'react-router-dom';
import LicenseChangesLog from '@/containers/licenseChangesLog/LicenseChangesLog';

const LicenseChangesLogPage = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <LicenseChangesLog />
            </Flex>
        </Container>
    );
};

export default LicenseChangesLogPage;
